var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2177_349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90234 21.6088C4.90234 22.2103 5.14129 22.7872 5.56663 23.2125C5.99196 23.6379 6.56883 23.8768 7.17034 23.8768C7.77185 23.8768 8.34873 23.6379 8.77406 23.2125C9.19939 22.7872 9.43834 22.2103 9.43834 21.6088C9.43834 21.0073 9.19939 20.4304 8.77406 20.0051C8.34873 19.5798 7.77185 19.3408 7.17034 19.3408C6.56883 19.3408 5.99196 19.5798 5.56663 20.0051C5.14129 20.4304 4.90234 21.0073 4.90234 21.6088Z",
    stroke: "#ECEAEB",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3765 21.6088C17.3765 22.2103 17.6154 22.7872 18.0407 23.2125C18.4661 23.6379 19.043 23.8768 19.6445 23.8768C20.246 23.8768 20.8228 23.6379 21.2482 23.2125C21.6735 22.7872 21.9125 22.2103 21.9125 21.6088C21.9125 21.0073 21.6735 20.4304 21.2482 20.0051C20.8228 19.5798 20.246 19.3408 19.6445 19.3408C19.043 19.3408 18.4661 19.5798 18.0407 20.0051C17.6154 20.4304 17.3765 21.0073 17.3765 21.6088Z",
    stroke: "#ECEAEB",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6443 19.3409H7.17034V3.46484H4.90234",
    stroke: "#ECEAEB",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17041 5.73242L23.0464 6.86642L21.9124 14.8044H7.17041",
    stroke: "#ECEAEB",
    strokeWidth: 2.016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2177_349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.216,
    height: 27.216,
    fill: "white",
    transform: "translate(0.366211 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarticon);
export default __webpack_public_path__ + "static/media/Carticon.02be0b97b403cf5010ceb6d22a973a46.svg";
export { ForwardRef as ReactComponent };